import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.auth.join');
import { OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-auth-join',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.auth.join/view.scss */
:host {
  display: block;
  height: 100%;
}

@keyframes float-slow {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(30px, -30px);
  }
}
@keyframes float-delay {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-20px, 20px);
  }
}
@keyframes float-mid {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(15px, 15px);
  }
}
.animate-float-slow {
  animation: float-slow 8s ease-in-out infinite;
}

.animate-float-delay {
  animation: float-delay 10s ease-in-out infinite;
}

.animate-float-mid {
  animation: float-mid 6s ease-in-out infinite;
}

@keyframes logo-glow {
  0%, 100% {
    filter: drop-shadow(0 0 8px rgba(246, 146, 50, 0));
  }
  50% {
    filter: drop-shadow(0 0 20px rgba(246, 146, 50, 0.3));
  }
}
.animate-logo-glow {
  animation: logo-glow 4s ease-in-out infinite;
}

@keyframes hero-fade {
  0% {
    opacity: 0;
    transform: translateY(-12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-hero-fade {
  animation: hero-fade 0.6s ease-out;
}

@keyframes feature-fade {
  0% {
    opacity: 0;
    transform: translateY(16px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-feature-1 {
  animation: feature-fade 0.4s ease-out 0.2s both;
}

.animate-feature-2 {
  animation: feature-fade 0.4s ease-out 0.3s both;
}

.animate-feature-3 {
  animation: feature-fade 0.4s ease-out 0.4s both;
}

.animate-feature-4 {
  animation: feature-fade 0.4s ease-out 0.5s both;
}

.animate-feature-5 {
  animation: feature-fade 0.4s ease-out 0.6s both;
}

.animate-feature-6 {
  animation: feature-fade 0.4s ease-out 0.7s both;
}`],
})
export class PortalAuthJoinComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;

    public form: any = {
        email: '',
        password: '',
        password_repeat: '',
        name: '',
        mobile: ''
    };

    public emailChecked = false;
    public pwError: string | null = null;
    public pwReError: string | null = null;

    constructor(@Inject( Service) public service: Service) { }

    async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(false, '/home');
        await this.service.render();
    }

    private showModal(message): Promise<boolean> {
        return this.modalMessage.open({ message });
    }

    onEmailChange() {
        this.emailChecked = false;
    }

    private emailValidator(email) {
        if (!email) return false;

        const re =
            /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        return re.test(email.trim());
    }

    async checkEmail() {
        this.emailChecked = false;

        if (!this.emailValidator(this.form.email)) {
            await this.showModal('이메일 형식이 맞지 않습니다.');
            return;
        }

        const { code } = await wiz.call('check', { email: this.form.email });

        if (code === 409) {
            await this.showModal('이미 가입된 메일입니다.');
            return;
        }

        if (code !== 200) {
            await this.showModal('이메일 확인 중 오류가 발생했습니다.');
            return;
        }

        this.emailChecked = true;
        await this.service.render();
    }

    validatePassword() {
        this.pwError =
            !this.form.password || this.form.password.length < 8
                ? '비밀번호는 8자리 이상이어야 합니다'
                : null;
    }

    validatePasswordRepeat() {
        this.pwReError =
            this.form.password !== this.form.password_repeat
                ? '비밀번호가 일치하지 않습니다'
                : null;
    }

    formatMobile() {
        this.form.mobile = this.form.mobile.replace(/[^0-9]/g, '');
    }

    async join() {

        if (!this.emailValidator(this.form.email)) {
            await this.showModal('올바른 이메일 형식이 아닙니다.');
            return;
        }

        if (!this.emailChecked) {
            await this.showModal('이메일 중복 확인을 해주세요.');
            return;
        }

        if (this.pwError || this.pwReError) {
            await this.showModal('비밀번호를 확인하세요.');
            return;
        }

        const { code } = await wiz.call('join', this.form);

        if (code !== 200) {
            await this.showModal('회원가입에 실패하였습니다. 정보를 확인해주세요.');
            return;
        }

        await this.showModal('회원가입이 완료되었습니다.');
        await this.service.render();
    }
}

export default PortalAuthJoinComponent;